export function manageOnKeyDown(keyEvent, keyCode, key, timeFormat) {
  if (allowTabBackspaceArrowsDelete(keyCode)) return;
  if (timeInputKeyHandler(key, timeFormat) === true) {
    keyEvent.preventDefault();
  }
}

function timeInputKeyHandler(key, format) {
  const allowedCharactersForTwentyFourHourFormat = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const allowedCharactersForTwelveHourFormat = allowedCharactersForTwentyFourHourFormat.concat([
    'a',
    'm',
    'p',
    'A',
    'M',
    'P',
  ]);
  const allowedCharacters =
    format === 'hh:mm A' ? allowedCharactersForTwelveHourFormat : allowedCharactersForTwentyFourHourFormat;
  return allowedCharacters.indexOf(key) === -1;
}

function allowTabBackspaceArrowsDelete(key) {
  const backspaceKey = 8;
  const deleteKey = 46;
  const leftArrowKey = 37;
  const rightArrowKey = 39;
  const tabKey = 9;
  const colonKey = 186;
  switch (key) {
    case backspaceKey:
    case deleteKey:
    case leftArrowKey:
    case rightArrowKey:
    case tabKey:
    case colonKey:
      return true;
    default:
      return false;
  }
}
